import type { GUID } from "@pdfking/tfunc"
import { UInt8Hash } from "@pdfking/tfunc"

const extractImageBytes = async (blob: Blob): Promise<Uint8ClampedArray> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement("canvas")
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext("2d")
      ctx.drawImage(img, 0, 0)
      const imageData = ctx.getImageData(0, 0, img.width, img.height)
      resolve(imageData.data)
    }
    img.onerror = reject
    img.src = URL.createObjectURL(blob)
  })

export const ImageHash = async (blob: Blob): Promise<GUID> => {
  const clamped = await extractImageBytes(blob)

  return UInt8Hash([
    new Uint8Array(clamped.buffer, clamped.byteOffset, clamped.byteLength),
  ])
}
